import { AppBar, Box, Toolbar } from "@mui/material";
import NASLogo from "../../Assets/NASLogo";
import { AppMenu } from "./Subcomponents/AppMenu/AppMenu";
import { DesktopNavMenu, MobileNavMenu } from "./Subcomponents/NavMenu/NavMenu";
import { UserMenu } from "./Subcomponents/UserMenu/UserMenu";

export default function NavBar(props: { userHasAccess: boolean }) {
  return (
    <AppBar
      id="app-nav"
      aria-label="CRM Navigation"
      role="banner"
      position="sticky"
      sx={{ maxHeight: "64px" }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: { xs: "0 1rem", lg: "0 2rem" },
          width: "100%",
          maxWidth: "2400px",
        }}
      >
        <Toolbar disableGutters>
          <AppMenu />
          <Box sx={{ display: "flex", alignItems: "center", px: 2 }}>
            <NASLogo
              sx={{
                "& svg": {
                  width: "100px",
                  height: "auto",
                },
              }}
            />
          </Box>
          {props.userHasAccess ? (
            <>
              <MobileNavMenu />
              <DesktopNavMenu />
            </>
          ) : null}
          <UserMenu />
        </Toolbar>
      </Box>
    </AppBar>
  );
}
